import { ChevronLeft } from "lucide-react";
import type { ReactNode } from "react";
import { Link } from "react-router";

/**
 * Reusable record page header for every Gravun module (contact, company,
 * deal, and later job/estimate/invoice): back link, avatar, title, subtitle,
 * status badges, and right-aligned actions. Never build per-module headers.
 */
export const RecordHeader = ({
  backTo,
  backLabel,
  avatar,
  title,
  subtitle,
  badges,
  actions,
}: {
  backTo: string;
  backLabel: string;
  avatar?: ReactNode;
  title: ReactNode;
  subtitle?: ReactNode;
  badges?: ReactNode;
  actions?: ReactNode;
}) => (
  <div className="mb-5 flex flex-col gap-3">
    <Link
      to={backTo}
      className="flex w-fit items-center gap-1 text-[12.5px] font-medium text-muted-foreground no-underline transition-colors hover:text-foreground"
    >
      <ChevronLeft className="size-3.5" />
      {backLabel}
    </Link>
    <div className="flex flex-wrap items-center justify-between gap-3">
      <div className="flex min-w-0 items-center gap-3">
        {avatar}
        <div className="min-w-0">
          <div className="flex flex-wrap items-center gap-2">
            <h1 className="truncate text-[20px] font-semibold leading-7 tracking-tight text-foreground">
              {title}
            </h1>
            {badges}
          </div>
          {subtitle ? (
            <div className="text-[13px] text-muted-foreground">{subtitle}</div>
          ) : null}
        </div>
      </div>
      {/* Wraps rather than shrink-0: an invoice's status actions are wider
          than a 390px viewport, and a non-wrapping row pushed the whole page
          sideways on a phone. */}
      {actions ? (
        <div className="flex flex-wrap items-center gap-2">{actions}</div>
      ) : null}
    </div>
  </div>
);
